import { createSlice } from "@reduxjs/toolkit";

const savedUsers = JSON.parse(localStorage.getItem("userData")) || [];

const userSlice = createSlice({
  name: "user",
  initialState: {
    users: savedUsers,
  },
  reducers: {
    addUser: (state, action) => {
      state.users.push(action.payload);
      localStorage.setItem("userData", JSON.stringify(state.users));
    },
  },
});

export const { addUser } = userSlice.actions;
export default userSlice.reducer;
